import React from "react";
import {
  Box,
  Chip,
  Typography,
  Tooltip,
} from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";

interface Hotel {
  id: number;
  name: string;
  hasData: boolean;
}

interface HotelDataStatusListProps {
  hotels: Hotel[];
  title?: string;
}

const HotelDataStatusList: React.FC<HotelDataStatusListProps> = ({
  hotels,
  title = "Statut des données",
}) => {
  if (hotels.length === 0) {
    return null;
  }

  return (
    <Box
      sx={{
        width: "95%",
        mb: 2,
        display: "flex",
        alignItems: "center",
        gap: 2,
        flexWrap: "wrap",
        justifyContent: "center",
      }}
    >
      {hotels.map((hotel) => (
          <Tooltip
            key={hotel.id}
            title={
              hotel.hasData
                ? "Données disponibles pour cette période"
                : "Aucune donnée pour cette période"
            }
            arrow
          >
            <Chip
              label={hotel.name}
              icon={
                hotel.hasData ? (
                  <CheckCircleIcon />
                ) : (
                  <CancelIcon />
                )
              }
              sx={{
                backgroundColor: hotel.hasData ? "#e8f5e9" : "#ffebee",
                color: hotel.hasData ? "#2e7d32" : "#c62828",
                fontWeight: 500,
                "& .MuiChip-icon": {
                  color: hotel.hasData ? "#4caf50" : "#ef5350",
                },
                "&:hover": {
                  backgroundColor: hotel.hasData ? "#c8e6c9" : "#ffcdd2",
                },
              }}
            />
          </Tooltip>
        ))}
    </Box>
  );
};

export default HotelDataStatusList;
